module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 col-12 p-0"
  }, [_c('div', {
    staticClass: "col-12 row mx-0 px-3 py-2",
    staticStyle: {
      "background-image": "linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123))",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][1]))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "font-size": "15px",
      "border-radius": "5px"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][0]))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][2]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.KHRemain),
      expression: "KHRemain"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "5",
      "size": "3",
      "name": "KHRemain",
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.KHRemain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.KHRemain = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("ml")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 pb-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][3]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][7]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.KHdosing),
      expression: "KHdosing"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "3",
      "size": "3",
      "name": "KHdosing",
      "type": "text",
      "value": "100"
    },
    domProps: {
      "value": (_vm.KHdosing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.KHdosing = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("ml")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 pb-0"
  }, [_vm._v(" " + _vm._s(_vm.msglist[_vm.$route.params.language][9]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][10]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxKHdosingPerHr),
      expression: "maxKHdosingPerHr"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "3",
      "size": "3",
      "name": "maxKHdosingPerHr",
      "type": "text",
      "value": "0"
    },
    domProps: {
      "value": (_vm.maxKHdosingPerHr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxKHdosingPerHr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("ml")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 pb-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][11]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][4]))]), _vm._v(" "), _c('div', {
    staticClass: "px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mlspec),
      expression: "mlspec"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "3",
      "size": "2",
      "name": "mlspec",
      "type": "text",
      "value": "100"
    },
    domProps: {
      "value": (_vm.mlspec)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mlspec = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("ml")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 pb-2"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][5]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][15]))]), _vm._v(" "), _c('div', {
    staticClass: "px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PairDev),
      expression: "PairDev"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "12",
      "size": "12",
      "name": "PairDev",
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.PairDev)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PairDev = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-auto px-0 pb-2"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][16]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-3 mb-1 justify-content-center",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [(_vm.name !== 'khacra') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "name": "KH_settings_button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][12]))]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFTklEQVR4nO2dTYgcRRTH/zPvzY6duBqjgQ0a1ChZxC80EEMuKoiGiKCSmwG/USIGMYf1EDwYEUW9CHoxB1FUIip4cP2IAQmoGExQIwaECH4QDRISNWPQmB152KOdt9WzM9PTU91d7w/vMvWq51X9uqq7qqu7AJPJ5EfjzWZzaccATHTxXZD0jf1Pj9MWqd8XzPG/C5X/GQhRjUbjTmZuJ2w6xXWciPYq398bjcaFkkhEW1Tapm7/S0Sbk/5E9CxCVI8Aasz8uvKbIaK1HQcDkCMAZp5SPnLGPpL0MQA5ASCiq5j5mPJ5T5IMQP4AJph5vzrzv3FdYK0FDB8AE9GOtIuuAcgZABE97bjo3px2HGsBQwRARGukwlXX82i342gAsf9paUZET9ltqAMAEe1m5gPqt08A1PsB0K/ZOIC7VlCr2WyebwBG0wW1U87QD2VAZi1gdACOOH5b3ysAInqu0WgsTzOHv01FcKLLYeZVzPymhhJPnM0JwOaCBm8BfxLRdXHyYmY+pNK3u7oiAzA8AO8k05n5Ht0VSR4DMLrJuJqc9crnMIAlSSdrAfkBwNjY2DJmPqr83jYAI3wgw8ybdFdUr9fXddKtBeQMAP9Ozu1Wvgc7jzANwIAiotXMvK1jRPRYmi8zr0j6xrYhTtuY/L1er98yB/jbXMcxmbpqIYDlAduVAFYCWNrFzpIGlsd5tBHA3wDaZuilDr4AsDkGklkyFfybVTwGOfn+ACDPJjgrBCFqZz8GroNtAE7NAuAGx0H3xweuum13lP1bAPsc9gOAv1IgTOvVHP3qDXXAXwGcieorclTmyV385Uy/C8CPjnwPZQlkMYBD6oBbUX1FfQLoaBGAT1W+w1nXod7vCEa6pyorGhAA4pH6Lyrvhqx3RB+rA37XR0ChARBNqbwfIKMudlxonkB1FWUEcJ7K+9MwgnpSHfQYgMtQTUUZAdTj+unkPT6MccG8+LYrGdTOrLdZFQUgOqLyzx9GYKsdgd2H6ikqKgDRawGMDaIiA5hwjA0ESpUUFRmAaH3FxwZR0QHIVf6jjGODSQAXZLDUZYshABBd4hgbPN5H/pajkP3Y0AtUNgCIKzz5J9/3kbdlALJLxgYz6mGEARhhC0AGALsA7M1g0k0g9C4oC4AiywB4lgHwLAPgWQbAswyAZxkAzwoCwKTHuZ65FASAlse5nrlkAGAAepa1gIrOBUXwpyC6oCLLAHiWAfAsA+BZBsCzDIBnGQDPCgLApK0L8gugZctSDEDQXVDLWoBfALtsXZBfAEVW1i7oJFUvR/N8wGQAZmuV4y373GQAZusFBeBF5CgDcKKujd+KTAK4ETnKAPyvmxyf+fky7zdJQwFwUcoXs1YAuBXA+4488sGrq/MONhQA7QHsgVEEG8q6oHYfJq9u3TuqYENZFdHu0eTDHJePMthQAOxLMflcw1sAHgZwqY9gQwFQQ0EVyrqgGgqqUO6CaiiojqtJpypoXpkAHFSBSvBl1xJVJiljYbVHBdt1/6+SaKUq01cosKZVsLP2eymhplSZTti9o2h6sEzB9qidPqYUBtU5KtiZuAmXVdc7LsDnouDaoQKWzTjHUD6Nx2OQZFlkS8XCSz+CE9tS5Fs3hyieUtCt+QqURFsdEF71PKLtVbJl+ruO+F9BiXQKgK8dhZA94dcWtDUQgNvjT9DruPfEXVKpJGOAAymTa/I1LdnB9A4AawBc48nkIns3gOcB/JwSq3xq2LmJaBkke6h8lmE+ve3ZPgdwNkqu+fHZnrazRLuAJrE+U5GplP+0DMDLQ1gH2s7RZBHtS6OeQvkHQ+EbJrXr1G8AAAAASUVORK5CYII="
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEHElEQVR4nNWaW6hVRRjHf2d/31paWBBpZVdCSKJMC6xMKoWKY3aTwgtdX4zqyUsv9WTQQxlEUHSgwjTK6EbWa/VQkWjaDUJMMy0xSyhLheR0dMfEfx3GzTn7nL33mn32/sPAWjPf/L/5r7Vm5puZBWkxAdgF7NR11+I5oKr0LF2KmcAAcFhpQHldBQe+1ptYBizX9XdARhdhpRr+JWBKW5S3gi7BmcBfwL/A5VH+ZUA/cAiYTBdgnZ786iHKnlHZWjocs4DjwG/AqUOUnwLsk821dCgqwGY98Xvr2N0vm6/UdzoOD6qBG4GeOnah7HPZLqXDcBpwADgGXDkK+ytk+wdwOh2EF/SEX2qgziuq8zwdgks01P4NnNVAvTOAg5rxp9MB+CiawRvFMtUNHGOKG9WQnU2GHpnqBo4bGCOE0WerGrG4BZ4l4ghc9Ua7ZFgSBYJhDmkWPVGAuZA2I/4kekvgu1lcO9odHT8kx5+WyPlZuydJ1/K1WnK8dH00cLQldLlbDjcl4P6ihMFj1Cg65q0JuG8X97epR7D5crStxZFqOPQA38vHPBKi6JAhFE+FB+Qj+EqC6XKwL/EQmclHVcvj0tEn8qdJj9WpIuPxim4D+aVFpruvM7OtZrYqNjazJ5Uf0hwzm1vcA5Ni2zzPLyrKsiwrouBp8hWi43FlCrkjWp7GDd7s7lV3H9xMqFQqi5VXNbMXZbegyAPOjjmyLJtRlLn77KjoG/m8pUwhrw0VqtcKyfN8qrsfkoiNxdNsUsjyFDsue0V6fh0hE8xsm+73A+dEds0IuUA+fy5LREH4U21BLMTd1+v6qLvPqrEbFJLn+cVa4/+f3P26YYQE7JHv8ygBc0X2fh0hv0eNeWcIu0EhI6TZNVU3yPecMoQsFFlfHSFxOubu19QRssfMdhXJ3ffWEdJX5jrlTpG9Xk+Ima0JjdT1dg3ZrfSRgJflewElflqfDCfEzEI4YWY2LxL2VAlCNsh3CPFbxrnR6o2R5hF3f0N5A+4+s0UhO+T7hDqtoIh9LhxJCDDR3Q/orYQoeXyTQqZEsV3aCdHdP3b3P4sZvEClUrkn5CutNLP5xX3tJl6WZdMi26uiohXy+WqZQnpFuqVNWzY9CoeCz5vKJLboe72L9FgkX9tTrN/vE/kPZUekNRgH/ChfYX8gyesuNgfWkA5ro62mZJ/xFB10pjqdfVTcv2rYT4penc6Gc8BVJT21wPGEOP8BrqZNCB3+qJ7euy2eOk0E3hPXYeA22owQNuxXA8Ln9hhwUgP1TwYejz7V3ak2G0b7c8D66MeZg7pfNMxPAZNV9mYk4LgC0hPW8mOFsJD6UMdo1SgdAX5ROlJTFmw/AOLZvGMQ4qhHgLc13/RHDe/XBPcW8HC3/MZBhNBvGuk7TeE/nQBuEwPUgzIAAAAASUVORK5CYII="
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": require("../assets/CRA.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58467744"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KH_dosing.vue
// module id = 524
// module chunks = 0